import i18n from 'i18next';
import React from 'react';
import { Box } from '@mui/material';
// import { subDomain } from 'api/ApiMethods';
import logo from 'assets/images/welcomepagelogo.svg';
import logoText from 'assets/images/TAG-logo-text.svg';
// import { Link } from 'react-router-dom';
import langKey from 'i18n/keys';

function LandingPage() {
  return (
    <div className="landing-page">
      <div className="t-bg-faint-blue logo_parent_div">
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexGrow: 1,
              justifyContent: {
                xs: 'start',
                md: 'center',
                lg: 'center',
                xl: 'center'
              },
              alignItems: 'center',
              height: '100%',
              paddingY: '5rem'
            }}
          >
            <img src={logoText} className="landing-page-logo" alt="TAG logo" />
            <img
              src={logo}
              className="landing-page-logo-mobile"
              alt="TAG logo mobile"
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexGrow: 1,
              justifyContent: {
                xs: 'start',
                md: 'center',
                lg: 'center',
                xl: 'center'
              },
              alignItems: 'center',
              height: '100%',
              paddingY: '5rem'
            }}
          >
            <div className="h1-fontsize-80">
              {i18n.t(langKey.landingpage_selectdomain)}
            </div>
          </Box>
        </Box>
      </div>
    </div>
  );
}

export default LandingPage;
